
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.00048 0C1.50048 5 3.34577 8.06653 8.32822 10.0147L8.66407 10.1425C9.18208 10.334 9.44675 10.9091 9.25526 11.4271C9.18345 11.6214 9.0531 11.7885 8.88221 11.9055C7.12169 13.1108 4.28138 13.8089 0.361328 14C1.00049 10.5 1.00043 6.5 1.00048 0Z","fill":"currentColor"}})])
          )
        }
      }
    